export enum DeliveryType {
  Regular = 'regular',
  Express = 'express',
  Rapid = 'rapid',
}
